import React from 'react';

import _ from 'topmeteo/utils/i18n';

import LightBox from 'topmeteo/general/components/LightBox';

import LayerSelect from './LayerSelect';
import ColoredCheckbox from './ColoredCheckbox';
import FAICheckbox from './FAICheckbox';

const Headline = _('Settings');

const SettingsLightBox = ({colored, layer, onLayerChange, onColoredChange, ...props}) => (
    <LightBox className="settings-light-box" {...props} hint>
        <h2>{Headline}</h2>
        <form>
            <LayerSelect />
            <ColoredCheckbox />
            <FAICheckbox />
        </form>
    </LightBox>
);

export default SettingsLightBox;
